export enum BulkActionStatus {
    PENDING,
    VALIDATING,
    IMPORTING,
    VALIDATION_FAILED,
    VALIDATION_COMPLETE_WITH_ERRORS,
    VALIDATION_COMPLETE,
    IMPORT_FAILED,
    IMPORT_COMPLETE,
}

export enum BulkValidationErrorType {
    FILE_TYPE_ERROR,
    FILE_FORMAT_ERROR,
    SERVER_VALIDATION_ERROR,
    DEFAULT_ERROR,
}

export enum FileColumnDataType {
    STRING,
    NUMBER,
    NUMBER_ARRAY,
    STRING_ARRAY,
    BOOLEAN,
}
